export default __webpack_public_path__ + "static/media/Bionic-Arm-09.42ad5da0.jpg";